enum RequireTimeEntryGps {
  NONE = 'none',
  SELF = 'self',
  CHILDREN = 'children',
  SELF_AND_CHILDREN = 'self_and_children',
}

export default RequireTimeEntryGps;
